import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { createAppRouter } from "./router";

import "./styles.css";

const queryClient = new QueryClient({
	defaultOptions: { queries: { staleTime: 60_000, retry: 1 } },
});
const router = createAppRouter({ queryClient });

// A client that loaded before a deploy may request a chunk that no longer exists; reload to pick up the new build.
window.addEventListener("vite:preloadError", () => {
	window.location.reload();
});

const rootElement = document.querySelector("#root");
if (!rootElement) {
	throw new Error("Root element #root not found");
}

createRoot(rootElement).render(
	<StrictMode>
		<QueryClientProvider client={queryClient}>
			<RouterProvider router={router} />
		</QueryClientProvider>
	</StrictMode>,
);
